module.exports = __webpack_public_path__ + "static/media/4.c917a69b.jpg";